<template>
  <tr v-on:click="giftSub">
    <td class="user-cell">
      <user :user_id="subBounty.user_id"></user>
    </td>
    <td class="ammount-cell">{{formatCurrency(subBounty.amount)}}</td>
    <td class="button-cell">
      <button-a class="gift-btn" v-on:clicked="giftSub">Gift{{`${tier === 2 ? ' Tier 2' : tier === 3 ? ' Tier 3' : ''}`}} Sub</button-a>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'bounty',
  props: ['subBounty', 'tier'],
  async created () {
    console.log('subBounty')
  },
  methods: {
    giftSub () {
      window.open(
        `https://www.twitch.tv/products/swiftor${this.tier === 2 ? '_2000' : this.tier === 3 ? '_3000' : ''}/ticket?recipient=${this.users[this.subBounty.user_id].twitch_name}`
      )
    }
  },
  data () {
    return {
      users: this.$store.state.users
    }
  }
}
</script>

<style scoped>
.user-cell{
  width: 25%;
}
.ammount-cell{
  width: 50%;
}
.button-cell{
    width: 25%;
}
.gift-btn {
  width: 80%;
}
</style>


// WEBPACK FOOTER //
// src/components/Bounty.vue